import React, { useEffect, useState } from 'react'
import { Card, CardContent } from '../../Common/ui/card'
import dayjs from 'dayjs'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import PropTypes from 'prop-types'
import { useMeetingStore } from '../../Containers/MeetingScheduler/Store/MeetingStore'

const EventCard = ({ meetTitle, date, startTime, endTime, onClick }) => {
    const formattedStartTime = dayjs(startTime).format('h:mm A')
    const formattedEndTime = dayjs(endTime).format('h:mm A')
    const formattedDate = dayjs(date).format('MMMM D')

    return (
        <Card className="mb-2 rounded-[10px]" onClick={onClick}>
            <CardContent className="py-2 pl-1">
                <div className="flex justify-start pl-1">
                    <div style={{ borderLeft: '5px solid hsl(var(--danger))' }} className="rounded-r-lg rounded-l-lg"></div>
                    <div className="flex justify-between w-full pl-2">
                        <div>
                            <p className="font-semibold text-sm">{meetTitle}</p>
                            <p className="text-gray-400 text-sm text-left">{formattedDate}</p>
                        </div>
                        <div className="flex flex-col items-end">
                            <p className="font-semibold text-sm">{formattedStartTime}</p>
                            <p className="text-gray-400 text-sm">{formattedEndTime}</p>
                        </div>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

const UpcomingEvent = ({ eventsData }) => {
    const { getUpcomingEvent } = useMeetingStore()
    const [ currentPage, setCurrentPage ] = useState(0)
    const selectedMeetingData = {
        meetTitle: 'TestMeeting',
        startTime: '2024-03-21T14:18:53.321',
        endTime: '2024-03-21T14:18:53.321',
        description: 'have to start',
        date: '2024-03-21T14:18:53.321',
        location: 'chennai',
        scheduleIn: 'Teams',
        createdBy: 2,
        attendeesList: [
            {
                userId: 1,
                userName: 'Abi'
            },
            {
                userId: 2,
                userName: 'Jannu'
            },
            {
                userId: 3,
                userName: 'Ram'
            },
            {
                userId: 4,
                userName: 'Kamal'
            }
        ]
    }
    const [ selectedMeeting, setSelectedMeeting ] = useState(selectedMeetingData)
    const eventsPerPage = 8

    useEffect(() => {
        getUpcomingEvent(eventsPerPage)
    }, [])

    const startIndex = currentPage * eventsPerPage
    const endIndex = Math.min(startIndex + eventsPerPage, eventsData.length)

    const goToPage = (page) => {
        setCurrentPage(page)
    }

    const handleCardClick = (meeting) => {
        setSelectedMeeting(meeting)
    }

    // Sorting eventsData by startTime
    const sortedEventsData = eventsData.sort((a, b) => new Date(a.startTime) - new Date(b.startTime))

    // Grouping events by date using Map
    const groupedEvents = new Map()
    sortedEventsData.forEach(event => {
        const date = dayjs(event.startTime).format('MMMM DD, YYYY')
        if (!groupedEvents.has(date)) {
            groupedEvents.set(date, [])
        }
        groupedEvents.get(date).push(event)
    })

    const eventEntries = [...groupedEvents.entries()]
    const totalPages = Math.ceil(eventEntries.length / eventsPerPage)
    const currentPageEvents = eventEntries.slice(startIndex, endIndex)

    return (
        <div>
            <p className='upcoming-title mb-4'>Upcoming Meetings</p>
            {currentPageEvents.map(([ date, events ]) => (
                <div key={date}>
                    <div>
                        {events.map((event, index) => (
                            <EventCard
                                key={index}
                                meetTitle={event.meetTitle}
                                location={event.location}
                                date={event.date}
                                startTime={event.startTime}
                                endTime={event.endTime}
                                scheduleIn={event.scheduleIn}
                                onClick={() => handleCardClick(event)}
                                selectedMeeting={selectedMeeting}
                            />
                        ))}
                    </div>
                </div>
            ))}
            {eventsData.length > 5 && (
                <div className="flex justify-end mt-4">
                    <button
                        onClick={() => goToPage(Math.max(0, currentPage - 1))}
                        disabled={currentPage === 0}
                        className="flex items-center px-2 py-1 mr-2 text-black focus:outline-none"
                    >
                        <FaChevronLeft className="ml-1"/>
                    </button>
                    <button
                        onClick={() => goToPage(currentPage + 1)}
                        disabled={currentPage === totalPages - 1}
                        className="flex items-center px-2 py-1 text-black focus:outline-none"
                    >
                        <FaChevronRight className="ml-1" />
                    </button>
                </div>
            )}
        </div>
    )
}

EventCard.propTypes = {
    meetTitle: PropTypes.string,
    date: PropTypes.string,
    startTime: PropTypes.string,
    endTime: PropTypes.string,
    onClick: PropTypes.func
}

UpcomingEvent.propTypes = {
    eventsData: PropTypes.array
}
export default UpcomingEvent
